// @flow

import styled from 'styled-components';
import React from 'react';
import { connect } from 'react-redux';
import type { Theme } from '../../../../types';
import { getEntries } from '../../../../helpers/index';
import type { SortOptions } from '../../../../store/assortment/config';
import { getSortOptionTranslation } from '../../../../store/assortmentSettings';
import { Select } from '../../../form';

const DropdownContainer = styled<any, Theme>('div')`
  flex-wrap: nowrap;
  display: flex;
`;

const Label = styled<any, Theme>('label')`
  align-self: center;
  margin-right: 1rem;
  flex: 0 0 auto;
`;

type OwnProps = {|
  onChange: Function,
  sortOptions: SortOptions,
  selected: string,
|};

type StateProps = {|
  getTranslation: (name: string) => string,
|};

type Props = {|
  ...OwnProps,
  ...StateProps,
|};

const SortDropdown = ({
  onChange,
  sortOptions,
  selected,
  getTranslation,
}: Props) => (
  <DropdownContainer>
    <Label>Sorteer op:</Label>
    <Select error={false} value={selected} onChange={e => onChange(e.target.value)}>
      {getEntries(sortOptions).map(([key]) => (
        <option key={key} value={key}>
          {getTranslation(key)}
        </option>
      ))}
    </Select>
  </DropdownContainer>
);

const mapStateToProps = (state): StateProps => ({
  getTranslation: sortOption => getSortOptionTranslation(state, sortOption),
});

export default connect<any, OwnProps, StateProps, any, any, any>(
  mapStateToProps,
)(SortDropdown);
